(() => {
  if (window.rbHomeInitialized) return;
  window.rbHomeInitialized = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root = document) {
    root.querySelectorAll('[data-rh-hero]:not([data-ready])').forEach(hero => {
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const dots = [...hero.querySelectorAll('[data-hero-dot]')];
      const cta = hero.querySelector('[data-hero-cta]');
      const pause = hero.querySelector('[data-hero-pause]');
      let current = 0, timer, paused = reduced.matches, hovering = false, focused = false, visible = true;
      const stop = () => clearInterval(timer);
      const schedule = () => {
        stop();
        if (!paused && !hovering && !focused && visible && !document.hidden && slides.length > 1) timer = setInterval(() => show(current + 1, false), 7000);
      };
      function show(index, announce = true) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { const active = i === current; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        cta.href = slides[current].dataset.url;
        cta.firstElementChild.textContent = slides[current].dataset.cta;
        if (announce) hero.querySelector('[data-hero-status]').textContent = slides[current].getAttribute('aria-label');
      }
      const manual = index => { show(index); paused = true; updatePause(); schedule(); };
      function updatePause() { pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); pause.textContent = paused ? '▶' : 'Ⅱ'; }
      dots.forEach((dot, i) => dot.addEventListener('click', () => manual(i)));
      hero.querySelector('[data-hero-prev]').addEventListener('click', () => manual(current - 1));
      hero.querySelector('[data-hero-next]').addEventListener('click', () => manual(current + 1));
      pause.addEventListener('click', () => { paused = !paused; updatePause(); schedule(); });
      hero.addEventListener('pointerenter', e => { if(e.pointerType==='mouse'){hovering = true; schedule();} });
      hero.addEventListener('pointerleave', e => { if(e.pointerType==='mouse'){hovering = false; schedule();} });
      hero.addEventListener('focusin', () => { focused = true; schedule(); });
      hero.addEventListener('focusout', () => setTimeout(() => { focused = hero.contains(document.activeElement); schedule(); }, 0));
      hero.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); manual(current + (e.key === 'ArrowRight' ? 1 : -1)); } });
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; updatePause(); schedule(); } });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: .15});
      observer.observe(hero);
      show(0, false); updatePause(); schedule();
    });
    root.querySelectorAll('[data-rh-rail]:not([data-ready])').forEach(rail => {
      rail.dataset.ready = 'true';
      const controls = rail.previousElementSibling, cards = [...rail.children];
      const prev = controls.querySelector('[data-rail-prev]'), next = controls.querySelector('[data-rail-next]');
      prev.setAttribute('aria-controls', rail.id); next.setAttribute('aria-controls', rail.id);
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
      function update() {
        const max = rail.scrollWidth - rail.clientWidth;
        controls.hidden = max < 3;
        rail.classList.toggle('is-scrollable', max > 3);
        prev.disabled = rail.scrollLeft < 3;
        next.disabled = rail.scrollLeft >= max - 3;
        const index = Math.min(cards.length - 1, Math.round(rail.scrollLeft / Math.max(1,step())));
        controls.querySelector('.rh-rail-count').textContent = `${index + 1} / ${cards.length}`;
      }
      function move(dir) { rail.scrollBy({left: step() * dir, behavior: reduced.matches ? 'instant' : 'smooth'}); }
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } });
      let drag = null, suppress = false;
      rail.addEventListener('dragstart', e => e.preventDefault());
      rail.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || rail.scrollWidth <= rail.clientWidth + 2) return;
        drag = {id:e.pointerId,x:e.clientX,y:e.clientY,start:rail.scrollLeft,active:false}; suppress = false;
      });
      rail.addEventListener('pointermove', e => {
        if (!drag || e.pointerId !== drag.id) return;
        const dx=e.clientX-drag.x, dy=e.clientY-drag.y;
        if (!drag.active && Math.abs(dy)>Math.abs(dx) && Math.abs(dy)>8) {drag=null;return;}
        if (!drag.active && Math.abs(dx)>8) {drag.active=true;rail.setPointerCapture(e.pointerId);rail.classList.add('is-dragging');}
        if (drag.active) {e.preventDefault();rail.scrollLeft=drag.start-dx;suppress=true;}
      });
      const finish = () => {
        if (!drag) return;
        const active=drag.active;
        if (rail.hasPointerCapture(drag.id)) rail.releasePointerCapture(drag.id);
        drag=null;rail.classList.remove('is-dragging');
        if (active) { const index=Math.round(rail.scrollLeft/Math.max(1,step()));rail.scrollTo({left:index*step(),behavior:reduced.matches?'instant':'smooth'});setTimeout(()=>suppress=false,350); }
      };
      rail.addEventListener('pointerup',finish);rail.addEventListener('pointercancel',finish);
      rail.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopPropagation();}},true);
      rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
    });
    const targets = root.querySelectorAll('.rh-heading,.rh-category,.rh-product,.rh-feature-grid>figure,.rh-feature-copy,.rh-trust-grid article,.rh-story-grid>*,.rh-review-grid figure');
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('rh-revealed');observer.unobserve(entry.target);}}),{threshold:.08,rootMargin:'0px 0px -20px 0px'});
      targets.forEach((el,i)=>{if(el.dataset.revealReady)return;el.dataset.revealReady='true';if(el.getBoundingClientRect().top>innerHeight){el.style.setProperty('--rh-delay',`${(i%3)*65}ms`);el.classList.add('rh-reveal');observer.observe(el);}});
      reduced.addEventListener('change',()=>{if(reduced.matches)targets.forEach(el=>el.classList.add('rh-revealed'));});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
